import React from 'react';
import { Box } from '@mui/material';

const ExchangeTag = ({ exchange, sx = {} }) => {
  if (!exchange) return null;
  return (
    <Box
      component="span"
      sx={{
        fontSize: '10px',
        fontWeight: 'bold',
        px: 0.6,
        py: 0.1,
        borderRadius: '4px',
        backgroundColor: 'action.hover',
        border: '1px solid',
        borderColor: 'divider',
        color: 'text.secondary',
        textTransform: 'uppercase',
        lineHeight: 1.2,
        display: 'inline-block',
        verticalAlign: 'middle',
        ...sx
      }}
    >
      {exchange}
    </Box>
  );
};

export default ExchangeTag;
